/**
 * shpflt-product-units — Keeps `[data-shpflt-units-badge]` counters on product
 * cards in sync with the live cart.
 *
 * Initial counts are server-rendered into the badge by the product card
 * snippet from `cart.items`. After any liquid-ajax-cart mutation we re-fetch
 * `/cart.js`, aggregate quantities by `product_id`, and write the totals
 * back to every badge on the page. Badges hide themselves (via the `hidden`
 * attribute) when their count is zero.
 */

const ENDPOINT = '/cart.js';

async function refreshUnitsBadges() {
  const badges = document.querySelectorAll('[data-shpflt-units-badge]');
  if (!badges.length) return;

  let cart;
  try {
    const response = await fetch(ENDPOINT, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    cart = await response.json();
  } catch {
    return;
  }

  const totals = new Map();
  for (const item of cart.items || []) {
    const id = String(item.product_id);
    totals.set(id, (totals.get(id) || 0) + item.quantity);
  }

  for (const badge of badges) {
    const productId = badge.dataset.productId;
    if (!productId) continue;
    const count = totals.get(String(productId)) || 0;
    badge.dataset.units = String(count);
    badge.textContent = String(count);
    if (count === 0) {
      badge.setAttribute('hidden', '');
    } else {
      badge.removeAttribute('hidden');
    }
    const baseLabel = badge.getAttribute('aria-label') || '';
    const labelTail = baseLabel.replace(/^\d+\s*/, '');
    badge.setAttribute('aria-label', `${count} ${labelTail}`.trim());
  }
}

document.addEventListener('liquid-ajax-cart:request-end', (e) => {
  if (!e.detail?.requestState?.responseData?.ok) return;
  refreshUnitsBadges();
});

// Refresh once after load in case the page was served from cache and the
// server-rendered counts are stale.
queueMicrotask(refreshUnitsBadges);
